export default __webpack_public_path__ + "static/logo-a43677ef41705bc4efd5f2a9524130ae.svg";